import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { setGeneralError } from '../../layout/components/UniversalModal/actions';


export function withErrorBoundary(isIgnoreError = true) {
  return (WrappedComponent) => {
    class ErrorBoundary extends React.PureComponent {
      constructor(props) {
        super(props);
        this.state = { hasError: false };
      }

      componentDidUpdate(prevProps, prevState) {
        const { setGeneralErrorConnect } = this.props;
        if (this.state.hasError !== prevState.hasError) {
          if (!isIgnoreError) {
            const options = {
              extraActions: [
                {
                  name: 'Refresh',
                  onClick: () => {
                    window.location.reload();
                  },
                },
              ],
            };
            setGeneralErrorConnect(
              'Something when wrong with the app. Please refresh your browser',
              options,
            );
          }
        }
      }

      componentDidCatch(error, info) {
        this.setState({ hasError: true });
        console.log(error, info);
      }

      render() {
        const { hasError } = this.state;
        if (!hasError) {
          return <WrappedComponent {...this.props} />;
        }
        return null;
      }
    }

    function mapDispatchToProps(dispatch) {
      return {
        setGeneralErrorConnect: (message, options) => {
          dispatch(setGeneralError(message, options));
        },
      };
    }

    return withRouter(
      connect(
        null,
        mapDispatchToProps,
      )(ErrorBoundary),
    );
  };
}



// WEBPACK FOOTER //
// ./foody/src/components/HOC/ErrorBoundaryHOC.jsx